import { useCallback } from 'react';
import type { FC, ReactNode } from 'react';
import { useSelector, useStore } from 'react-redux';

import { dealerSelectors } from '@makemydeal/dr-shared-store';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import { DealAssistantProvider } from '@makemydeal/dr-dash-deal-assistant';
import type { StateTree } from '@makemydeal/dr-dash-types';
import type { RealState } from '@makemydeal/shared-scoped-store';

import { getPrimaryScenarioSubtitle } from './getPrimaryScenarioSubtitle';

export const DealAssistantProviderGate: FC<{ children: ReactNode }> = ({ children }) => {
    const isEnabled = useSelector(dealerSelectors.isDealAssistantEnabled);
    const store = useStore<StateTree & RealState>();
    const getOfferSnapshot = useCallback(() => offerSelectors.getWorkingOffer(store.getState()).offer, [store]);
    const getDealStructureSnapshotLabel = useCallback(() => getPrimaryScenarioSubtitle(store.getState()), [store]);

    return isEnabled ? (
        <DealAssistantProvider getOfferSnapshot={getOfferSnapshot} getDealStructureSnapshotLabel={getDealStructureSnapshotLabel}>
            {children}
        </DealAssistantProvider>
    ) : (
        <>{children}</>
    );
};
